/* eslint-disable react/prop-types */
import { Paragraph, Typography } from '@tmov/design-system';
import { compareDesc } from 'date-fns';
import React, { useEffect, useMemo } from 'react';

import { formatarMoeda } from '../../../../helpers/formatador';
import useTimer from '../../../../hooks/useTimer';
import StatusCotacaoEnum from '../../Enum/StatusCotacaoEnum';
import { ContainerTimer } from './styles';

export default function CotacaoTimer({
  status,
  periodoFim,
  bestLance,
  fetchCotacao,
}) {
  const { stoppedTimer, days, hours, minutes, seconds } = useTimer(periodoFim);

  const remainingTime = useMemo(() => {
    const totalHours = Number(days) * 24 + Number(hours);
    const daysCounter = totalHours < 24 ? '' : ` (${days} dias)`;
    return `${totalHours}:${minutes}:${seconds} ${daysCounter}`;
  }, [days, hours, minutes, seconds]);

  useEffect(() => {
    const onInit = async () => {
      if (periodoFim) {
        const now = new Date();
        const fim = new Date(periodoFim);
        const dateValid = compareDesc(now, fim);

        if (dateValid && stoppedTimer) await fetchCotacao();
      }
    };

    onInit();
  }, [fetchCotacao, periodoFim, stoppedTimer]);

  return (
    <ContainerTimer>
      <Typography variant="h4">
        {StatusCotacaoEnum.getTipo(status)?.label}
      </Typography>
      <div>
        <Paragraph>Tempo restante</Paragraph>
        <Paragraph fontWeight="semibold">{remainingTime}</Paragraph>
      </div>
      <div>
        <Paragraph>Melhor lance</Paragraph>
        <Paragraph fontWeight="semibold">{formatarMoeda(bestLance)}</Paragraph>
      </div>
    </ContainerTimer>
  );
}
